<table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
  <tr style="text-align: center;">
    <th style="padding: 5px; border: 1px solid #000000;">Type</th>
    <th style="padding: 5px; border: 1px solid #000000;">Date</th>
    <th style="padding: 5px; border: 1px solid #000000;">Doc #/Desc</th>
    <th style="padding: 5px; border: 1px solid #000000;">Outstanding</th>
    <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
    <th style="padding: 5px; border: 1px solid #000000;">Payment</th>
  </tr>
  @if (knockoffItems?.length) {
  @for (item of knockoffItems; track item) {
  <tr style="border: 1px solid #000000">
    <td style="text-align: center; border: 1px solid #000000;">{{ item.type }}</td>
    <td style="text-align: center; border: 1px solid #000000;">{{ item.date }}</td>
    <td style="line-height: 16px; border: 1px solid #000000;">
      <div style="font-weight: 600; font-size: 14px; color: #08306B;">{{ item.docNo }}</div>
      <div style="font-size: 12px;">{{ item.description }}</div>
    </td>
    <td style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.outstanding | price }}</td>
    <td style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.amount | price }}</td>
    <td style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.payment | price
      }}</td>
  </tr>
  }
  }
  @else {
  <tr>
    <td colspan="6" style="text-align: center; padding: 12px; border: 1px solid #000000;">No knockoff records available.
    </td>
  </tr>
  }
</table>

<div style="display: flex; margin: 12px 0 24px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
  <div style="margin-left: auto; font-weight: 600; font-size: 14px;">
    <table cellpadding="0">
      <tr>
        <td style="text-align: right;"><b>UNMATCHED AMOUNT</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{ currencyCode }}
          {{ unmatchedAmount | number: '1.2-2' }}</td>
      </tr>
    </table>
  </div>
</div>